export const apiRoutes = {
    QUESTION_BANK: `/qb/questions`,
    QUESTIONS_BANK_DETAIL: (questionId: string) => `/qb/questions/${questionId}`,
    QUESTION_PAPER: (testId: string, sectionId?: string, lang?: string) => {
        const params = new URLSearchParams();
        if (sectionId) params.append('sectionId', sectionId);
        if (lang) params.append('language', lang);
        const queryString = params.toString();
        return `/tests/${testId}/questions-view${queryString ? `?${queryString}` : ''}`;
    },

    SECTION_QUESTION_MAPPING_DETAIL: (mappingId: string) =>
        `/sections-question-mappings/${mappingId}`,

    TEST_RESULT: (testId: string, mappingId: string) =>
        `/test-series/test/${testId}/mappings/${mappingId}/result`,
    SECTION_QUESTION_MAPPINGS: (testId: string) => `/sections-question-mappings/${testId}/bulk`,
    VIDEO_STATS: (videoId: string, page: number, limit: number) =>
        `/videos/${videoId}/stats?page=${page}&limit=${limit}`,
    TEST_SERIES_LANGUAGES: `/tests-series/languages`,

    MASTER_CLASSES: `/master-classes`,
    MASTER_SUBJECTS: `/master-subjects`,
    MASTER_CHAPTERS: (subjectId?: string) =>
        subjectId ? `/master-chapters?subjectId=${subjectId}` : `/master-chapters`,
    MASTER_TOPICS: (chapterId?: string, subjectId?: string) => {
        const params = new URLSearchParams();
        if (chapterId) params.append('chapterId', chapterId);
        if (subjectId) params.append('subjectId', subjectId);
        return params.toString() ? `/master-topics?${params.toString()}` : `/master-topics`;
    },

    // ecom------
    ECOM_ORDERS: `/ecom-orders`,
    GET_ECOM_PRODUCTS: (type: string, typeId: string) => `/ecom/${type}/${typeId}/products`,
    ECOM_CATEGORIES: `/ecom/categories`,

    // live channels
    LIVE_CHANNELS: `/live-videos/channel`,

    BULK_UPLOAD_TYPES: `/bulk-uploads/types`,
    GET_ECOM_USERS: (type: string, typeId: string) => `/${type}/${typeId}/users`,
    DELETE_ASSIGNED_USERS: (type: string, typeId: string, userId: string) =>
        `/${type}/${typeId}/users/${userId}`,

    // batches
    BATCH_TOPICS: `/batches/batch-topics`,
    BATCH_SCHEDULE_TEMPLATES: `/batches/schedule-templates`,
    BATCH_TEMPLATE_SUBJECTS: `/batches/templates/subjects`,
    BATCH_SCHEDULE: `/batches/schedules`,
};
